import { render } from "./CollectionPane.vue?vue&type=template&id=507716d2&scoped=true"
import script from "./CollectionPane.vue?vue&type=script&lang=js"
export * from "./CollectionPane.vue?vue&type=script&lang=js"

import "./CollectionPane.vue?vue&type=style&index=0&id=507716d2&scoped=true&lang=css"

import exportComponent from "/Users/beerebeerey/github-classroom/MUICCS/cs340prj-beersilver/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507716d2"]])

export default __exports__